import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OrganizationsTable } from '../../../components/Organizations/OrganizationsTable';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const OrganizationsSubpage: FC = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageAdministration()} title={t('organizations.title', { count: 2 })}>
      <OrganizationsTable />
    </Page>
  );
};
